import { Container, Card } from '@dma/ui';
import type { AboutContentDto } from '../application/dto/AboutContentDto';
import './CeoMessage.css';

export interface CeoMessageProps {
  message: AboutContentDto['ceoMessage'];
  ceoName: AboutContentDto['ceoName'];
}

export function CeoMessage({ message, ceoName }: CeoMessageProps) {
  return (
    <section className="dma-ceo-message" aria-labelledby="dma-ceo-message-heading">
      <Container>
        <Card>
          <h2 id="dma-ceo-message-heading">پیام مدیرعامل</h2>
          <blockquote className="dma-ceo-message__quote">{message}</blockquote>
          <p className="dma-ceo-message__name">{ceoName}</p>
        </Card>
      </Container>
    </section>
  );
}
